export default "skymp5-front/e93c33809c217883f488534dad854b9a.png";